<template>
  <q-table
  :pagination.sync="pagination"
  flat
  :data="advertiserInvoices"
  :columns="columns"
  :rows-per-page-options="[10, 20, 50, 100]"
  bordered>
    <template v-slot:body-cell-type="props">
      <q-td :props="props">
        {{ props.row.type == 'nfs' ? 'Nota Fiscal' : 'Fatura' }}
      </q-td>
    </template>

    <template v-slot:body-cell-value="props">
      <q-td :props="props">
        R$ {{ props.row.type == 'nfs' ? props.row.payment_plan_parcels_sum_value : props.row.value_to_invoice }}
      </q-td>
    </template>
    <template v-slot:body-cell-invoice="props">
      <q-td :props="props">
        <q-btn
          flat
          :disable="props.row.type == 'nfs'"
          color="primary"
          @click="showInvoice(props.row.id)"
          icon="fas fa-file-invoice-dollar"
        />
      </q-td>
    </template>
    <template v-slot:body-cell-cancel="props">
      <q-td :props="props">
        <q-btn flat color="red" @click="cancelInvoice(props.row.id)" icon="fas fa-ban" />
      </q-td>
    </template>
    <template v-slot:bottom>
      <div class="row items-center" style="width: 100%">
        <span class="q-mr-xs">{{$t('rows_per_page')}}</span>
        <q-select
          v-model="pagination.rowsPerPage"
          :options="[10, 20, 50, 100]"
          @change="updateRowsPerPage"
          dense
          style="max-width: 60px; padding-left: 8px; padding-right: 8px"
        />
        <span>Total: {{ advertiserInvoices.length }}</span>
        <div style="flex-grow: 1"></div>
        <q-pagination
          unelevated
          v-model="pagination.page"
          color="primary"
          :max="Math.ceil(advertiserInvoices.length / pagination.rowsPerPage)"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </div>
    </template>
  </q-table>
</template>

<script>
import FinancialMixin from '@/mixins/FinancialMixin.js';
import FinanceService from '@/services/FinanceService.js';
export default {
  name: 'ListAdvertiserInvoice',
  mixins: [FinancialMixin, FinanceService],
  data() {
    return {
      pagination: {
        sortBy: 'created_at',
        descending: true,
        rowsPerPage: 10
      },
      columns: [
        {
          name: 'type',
          label: 'Tipo',
          align: 'center',
          field: 'type'
        },
        {
          name: 'advertiser_name',
          required: true,
          label: this.$t('advertiser'),
          align: 'left',
          field: 'advertiser_name'
        },
        {
          name: 'period',
          required: true,
          label: this.$t('period'),
          align: 'left',
          field: 'periodo'
        },
        {
          name: 'invoice',
          required: true,
          label: this.$t('invoice'),
          align: 'center',
          field: 'id'
        },
        {
          name: 'value',
          required: true,
          label: this.$t('value'),
          align: 'left',
          field: 'cost'
        },
        {
          name: 'cancel',
          required: true,
          label: this.$t('cancel'),
          align: 'center',
          field: 'id'
        }
      ]
    };
  },
  methods: {
    async showInvoice(id) {
      let route = this.$router.resolve({ path: `/advertiser/invoice/pdf/${id}` });
      window.open(route.href, '_blank');
    },

    async cancelInvoice(id) {
      try {
        this.onLoading(true);
        const { data, status } = await this.deleteAdvertiserInvoice(id);
        if (status == 200) {
          this.successNotify(data.message);
          this.ActionSetAdvertiserInvoiceUpdate(true);
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>

<style></style>
